var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFileGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V4.625H23V2H2ZM12.5 7.25L4.625 15.125H9.875V23H15.125V15.125H20.375L12.5 7.25Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileGray);
export default __webpack_public_path__ + "static/media/add-file-gray.d82cc6137bcc2f9c79a9a8037249cd37.svg";
export { ForwardRef as ReactComponent };